import { combineEpics } from 'redux-observable'
import { StoreDispatch } from 'interfaces/component'
import accounts from 'epics/accountsEpic'
import analytics from 'epics/analyticsEpic'
import auth from 'epics/authEpic'
import bounty from 'epics/bountyEpic'
import communication from 'epics/communicationEpic'
import credit from 'epics/creditEpic'
import { beaconEpics } from 'components/features/beacon/epics'
import feed from 'epics/feedEpic'
import fonts from 'epics/fontsEpic'
import form from 'epics/formEpic'
import generic from 'epics/genericEpic'
import global from 'epics/globalEpic'
import insights from 'epics/insightsEpic'
import liveUpdate from 'epics/liveUpdateEpic'
import locations from 'epics/locationsEpic'
import opportunities from 'epics/opportunitiesEpic'
import viewport from 'epics/viewportEpic'
import member from 'epics/memberEpic'
import moneyflow from 'epics/moneyflowEpic'
import navigation from 'epics/navigationEpic'
import networth from 'epics/networthEpic'
import offers from 'epics/offersEpic'
import onboarding from 'epics/onboardingEpic'
import peergroups from 'epics/peergroupsEpic'
import property from 'epics/propertyEpic'
import providers from 'epics/linkageEpic'
import recaptcha from 'epics/recaptchaEpic'
import social from 'epics/socialEpic'
import utility from 'epics/utilityEpic'
import { Epic } from 'interfaces/middleware'
import { RESET_STATE } from 'actions/globalActions'
import flushDate from 'epics/flushDateEpic'
import userImageEpics from 'epics/userImageEpic'
import { composeEpic } from 'epics/composeEpic'
import { webviewEpic } from 'epics/webVewEpic'
import { deviceEpic } from 'epics/deviceEpic'
import { composeSubmitEpic } from 'epics/composeSubmitEpic'
import { composeMountEpic } from 'epics/composeMountEpic'
import { transactionEpic } from 'epics/transactionsEpic'
import { floatingPanesEpic } from 'epics/floatingPanesEpic'
import { sidebarEpic } from 'epics/sidebarEpic'
import { publicDashboardEpic } from 'epics/publicDashboardEpic'
import { socialInsightsEpic } from 'epics/socialInsightsEpic'
import { stripeEpic } from 'epics/stripeEpic'
import { subscriptionEpic } from 'epics/subscriptionEpic'
import { webSocketEpic } from 'components/features/webSocket/webSocketEpic'
import { futureEpic } from 'epics/futureEpic'
import { futureEpic as nextFutureEpic } from 'components/features/future/epics'
import { byType } from 'rxOperators/byType'
import { end } from 'rxOperators/end'
import { advisorEpic } from 'components/features/coaching/advisorStore/epics'
import { advisorVideoCallEpic } from 'components/features/coaching/advisorVideoCall/epics'
import { videoCallEpics } from 'components/features/videoCalls/epics'
import { rewardsPaneEpic } from 'components/features/rewards/rewardsPane/store/epics'
import { cardLandingEpic } from 'components/features/creditCard/creditCardLanding/epics'
import { creditCardEpic } from 'components/features/creditCard/creditCardStore/epics'
import { pageFiltersEpics } from 'components/features/pageFilters/epics'
import { testGQLEpic } from 'graphql/store'

const epics = combineEpics(
  communication, // should to handle registerEpic before authEpic
  accounts,
  analytics,
  auth,
  bounty,
  credit,
  beaconEpics,
  fonts,
  form,
  generic,
  global,
  insights,
  liveUpdate,
  locations,
  viewport,
  member,
  moneyflow,
  navigation,
  networth,
  offers,
  onboarding,
  opportunities,
  peergroups,
  property,
  providers,
  recaptcha,
  social,
  utility,
  feed,
  composeSubmitEpic,
  composeMountEpic,
  composeEpic,
  flushDate,
  userImageEpics,
  webviewEpic,
  deviceEpic,
  transactionEpic,
  floatingPanesEpic,
  sidebarEpic,
  publicDashboardEpic,
  socialInsightsEpic,
  stripeEpic,
  subscriptionEpic,
  webSocketEpic,
  futureEpic,
  nextFutureEpic,
  advisorEpic,
  advisorVideoCallEpic,
  videoCallEpics,
  cardLandingEpic,
  rewardsPaneEpic,
  creditCardEpic,
  pageFiltersEpics,
  testGQLEpic,
)

const replaceEpicsEpic: Epic = (action$) =>
  action$
    .pipe(byType(RESET_STATE))
    .pipe(end(({ payload: actionsCreator }) => {
      if (resetStateCallback) {
        resetStateCallback(allEpics)
      }

      if (dispatchCallback && actionsCreator) {
        actionsCreator().forEach(dispatchCallback)
      }
    }))

const allEpics = combineEpics(
  replaceEpicsEpic,
  epics
)

let resetStateCallback: Function | null = null
let dispatchCallback: StoreDispatch | null = null
export const onResetState: (callback: Function, dispatch: StoreDispatch) => void = (callback, dispatch) => {
  resetStateCallback = callback
  dispatchCallback = dispatch
}

export default allEpics
